import Icon from "@mui/icons-material/BugReportRounded";

export default function DebuggerIcon(props) {
	return <Icon color={props.color} />;
}
